import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Martín González',
  location: 'Buenos Aires, Argentina',
  text: 'Nunca pude ser constante con mis gastos hasta que probé este sistema. Es muy intuitivo y, como funciona en Google Sheets, puedo revisarlo desde el celular en cualquier momento. Un 10.',
  rating: 5
}, {
  name: 'Daniela Restrepo',
  location: 'Medellín, Colombia',
  text: 'Tenía varias deudas y no sabía por dónde empezar. Ver todas mis cuotas y fechas de pago en un mismo lugar me dio calma y un plan concreto. En tres meses terminé de pagar dos tarjetas.',
  rating: 5
}, {
  name: 'Javier Ortega',
  location: 'Madrid, España',
  text: 'Lo mejor es que no es complicado. Probé aplicaciones que pedían conectar mi banco y no me daban confianza. Aquí soy yo quien lleva el control y en diez minutos ya lo tenía funcionando.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-10 md:py-20 bg-white" data-id="element-176" data-mp="h4wva3k7seiq">
      <div className="container mx-auto px-4 md:px-6" data-id="element-177" data-mp="h8azlhcfuxst">
        <div className="text-center mb-6 md:mb-12" data-id="element-178" data-mp="m62sadkwqny2">
          <h2 className="font-display text-2xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-2 md:mb-4" data-id="element-179" data-mp="77s7jzaq0azt">
            Lo que dicen quienes ya tomaron el control
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-180" data-mp="c8okt3gyp9hw">
            Personas comunes que pasaron del desorden a la claridad financiera.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-181" data-mp="14ura2qo3gd5m">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 p-4 md:p-8 rounded-2xl relative border border-gray-100 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-182" data-mp="v5pp0m2oz5ks" data-mpi={index}>
              <Quote className="absolute top-3 right-3 md:top-6 md:right-6 w-6 h-6 md:w-8 md:h-8 text-teal-600/10" data-id="element-183" data-mp="1ofrf4r1lyeof" />

              <div className="flex gap-1 mb-2 md:mb-4" data-id="element-184" data-mp="1jkc1o07iiksj">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-amber-400 text-amber-400" data-id="element-185" data-mp="1ekzhxobxttu6" data-mpi={i} />)}
              </div>

              <p className="text-sm md:text-base text-gray-700 mb-3 md:mb-6 leading-relaxed flex-1" data-id="element-186" data-mp="14r8xqvmug5ka">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-2 md:gap-3 mt-auto" data-id="element-187" data-mp="vrlu036n6no2">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-teal-50 flex items-center justify-center text-teal-600 font-bold text-base md:text-lg" data-id="element-188" data-mp="qt0rfx3x3rwg">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-189" data-mp="37epbhbndbcea">
                  <h4 className="font-bold text-gray-900 text-xs md:text-sm" data-id="element-190" data-mp="37e5txw1mqq0s">
                    {testimonial.name}
                  </h4>
                  <p className="text-[10px] md:text-xs text-gray-500" data-id="element-191" data-mp="3ggf0ybxow19f">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}